"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = function NotFound(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'app-content'
  }, /*#__PURE__*/_react.default.createElement("h1", null, props.t('This is not the site you are looking for')), /*#__PURE__*/_react.default.createElement("a", {
    href: "/"
  }, props.t('Back to the homepage')));
};

NotFound.propTypes = {
  t: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(NotFound);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/not-found/index.js
// module id = 756
// module chunks = 0